import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { ActivatedRoute, Router } from '@angular/router';

@Component
({
    selector: 'public-app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit 
{
    secure : boolean;

    constructor
    (
        private router : Router
    )
    {
        console.log('In Header');
    }
    ngOnInit()
    {
        this.secure = true;
    }
    
    gotoCitations()
    {
        console.log('citations errors');
        this.router.navigate(['/citations']);
    }        
}
